import PythonIcon from "./Icons/python.svg";
import ReactIcon from "./Icons/react.svg";
import { FOLD_STATE, ICONS, Icon, Project } from "./ProjectTypes";

const TOTAL_PIECES = 6;

const ICONS_TO_SVGS: Record<Icon, typeof PythonIcon> = {
    [ICONS.PYTHON]: PythonIcon,
    [ICONS.REACT]: ReactIcon,
};

type BasePiecePercent = {
    xPercent: number;
    yPercent: number;
};

function ProjectComponentWrapper({ foldState, project }: { foldState: FOLD_STATE, project: Project }) {
    return <ProjectComponent foldState={foldState} name={project.name} tagline={project.tagline} fullDescription={project.fullDescription} icons={project.icons} />;
}

function ProjectComponent({ foldState, name, tagline, fullDescription, icons }: { foldState: FOLD_STATE, name: string, tagline: string, fullDescription: string, icons: Icon[] }) {
    let basePercent: BasePiecePercent;
    let currentNumPieces: number;
    let basicInfoFoldState: string;
    let fullFoldState: string;

    switch (foldState) {
        case FOLD_STATE.NAME:
            basePercent = { xPercent: 100, yPercent: 100 };

            currentNumPieces = 1;
            basicInfoFoldState = "";
            fullFoldState = "";
            break;
        case FOLD_STATE.BASIC_INFO:
            basePercent = { xPercent: 50, yPercent: 50 };

            currentNumPieces = 3;
            basicInfoFoldState = "foldOut";
            fullFoldState = "";
            break;
        case FOLD_STATE.FULL:
            basePercent = { xPercent: 25, yPercent: 12.5 };

            currentNumPieces = TOTAL_PIECES;
            basicInfoFoldState = "foldOut";
            fullFoldState = "foldOut";
            break;
    }

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <div style={{ width: `${basePercent.xPercent}%`, height: `${basePercent.yPercent}%` }} className="projectPiece">
                {name}
            </div>
            <div style={{ width: `${basePercent.xPercent}%`, height: `${basePercent.yPercent}%` }} className={`projectPiece foldFromTop ${basicInfoFoldState}`}>
                {tagline}
            </div>
            <div style={{ width: `${basePercent.xPercent * 2}%`, height: `${basePercent.yPercent}%` }} className={`projectPiece foldFromLeft ${basicInfoFoldState}`}>
                <div className="iconGrid">
                    {icons.map((icon) => ICONS_TO_SVGS[icon])}
                </div>
            </div>
            <div style={{ width: `${basePercent.xPercent * 2}%`, height: `${basePercent.yPercent * 2}%` }} className={`projectPiece foldFromTop ${fullFoldState}`}>
                <div className="fullDescriptionPiece topLeftPiece">
                    {fullDescription}
                </div>
            </div>
            <div style={{ width: `${basePercent.xPercent * 4}%`, height: `${basePercent.yPercent * 2}%` }} className={`projectPiece foldFromLeft ${fullFoldState}`}>
                <div className="fullDescriptionPiece topRightPiece">
                    {fullDescription}
                </div>
            </div>
            <div style={{ width: `${basePercent.xPercent * 4}%`, height: `${basePercent.yPercent * 4}%` }} className={`projectPiece foldFromTop ${fullFoldState}`}>
                <div className="fullDescriptionPiece bottomPiece">
                    {fullDescription}
                </div>
            </div>
        </div>
    );
}

export default ProjectComponentWrapper;
